// Custom script - checks if Live Chat is active and then outputs status in desktop and mobile navs

var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function() {
  setTimeout(function() {
      var chatOnline = GorgiasChat.isChatOnline(); // Check if chat is online (true or false).

      var divElements = document.getElementsByClassName('chat-status');

      for (var i = 0; i < divElements.length; i++) {
          var divElement = divElements[i];
          if (chatOnline) {
              divElement.classList.add('online');
          } else {
              divElement.classList.add('offline');
          }
      }
  }, 500);
});